import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  VStack,
  Button,
  Input,
  Select,
  useToast,
  Text,
} from "@chakra-ui/react";
import { categories } from "./utils";
import axiosInstance from "../../helpers/axiosInstance";
import Translate from "../../components/LanguageTranslation/Translate";

const PackingListModal = ({
  isModalOpen,
  closeModal,
  selectedTrip,
  tripMembers,
  fetchPackingLists,
}) => {
  const toast = useToast();
  const [listName, setListName] = useState("");
  const [newCategory, setNewCategory] = useState("");
  const [newItems, setNewItems] = useState([]);
  const [selectedMember, setSelectedMember] = useState("");
  const [currentItem, setCurrentItem] = useState(""); // Input field for current item

  const handleSaveList = async () => {
    if (!listName || !newCategory || !selectedMember) {
      toast({
        title: "Error",
        description: "Please fill in all fields.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    const payload = {
      packing_list_name: listName,
      trip_companion: selectedMember,
      packing_category: newCategory,
      packing_list_items: newItems.map((item) => ({
        name: item,
        completed: false,
      })),
    };

    try {
      const response = await axiosInstance.post(`/packing_lists/${selectedTrip}/`, payload);
      if (response.data.success) {
        fetchPackingLists(); // TODO: DO I need to re-fetch?

        toast({
          title: "Success",
          description: "Packing list created successfully.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });

        setListName("");
        setNewCategory("");
        setNewItems([]);
        setSelectedMember("");
        setCurrentItem(""); // Reset current item input field
        closeModal();
      }
    } catch (error) {
      toast({
        title: "Error",
        description: "Failed to create packing list.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Modal isOpen={isModalOpen} onClose={closeModal} size={{ base: "xs", md: "md" }}>
      <ModalOverlay />
      <ModalContent
        maxH="77vh"
        overflowY="auto"
        sx={{
          "&::-webkit-scrollbar": {
            display: "none",
          },
          msOverflowStyle: "none",
          scrollbarWidth: "none",
        }}
      >
        <ModalHeader>
          <Translate text="Add Category" />
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4} align="start">
            <Select
              placeholder={Translate({
                text: "Select Category",
                as: "string",
              })}
              value={newCategory}
              onChange={(e) => setNewCategory(e.target.value)}
              size="sm"
              borderRadius="xl"
            >
              {categories.map((c) => (
                <option key={c} value={c}>
                  <Translate text={c} />
                </option>
              ))}
            </Select>
            <Input
              placeholder={Translate({
                text: "Sublist Name",
                as: "string",
              })}
              value={listName}
              onChange={(e) => setListName(e.target.value)}
              size="sm"
              borderRadius="xl"
            />
            <Select
              placeholder={Translate({
                text: "Select Companion",
                as: "string",
              })}
              value={selectedMember}
              onChange={(e) => setSelectedMember(e.target.value)}
              size="sm"
              borderRadius="xl"
            >
              {tripMembers.map((member) => (
                <option key={member.email} value={member.username}>
                  <Text>{member.username}</Text>
                </option>
              ))}
            </Select>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button
            bg="#286328"
            color="white"
            _hover="none"
            mr={3}
            onClick={handleSaveList}
            borderRadius="lg"
          >
            <Translate text="Save" />
          </Button>
          <Button onClick={closeModal} borderRadius="lg">
            {" "}
            <Translate text="Cancel" />
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default PackingListModal;
